import React, {useMemo, useState} from "react";
import {Modal, ScrollView, View} from "react-native";
import P from "../lib/P";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import Btn from "./Btn";
import Div from "../lib/Div";
import {FormikProps} from "formik";
import MainStyle from "../../MainStyle";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import AmountSelect from "./AmountSelect";
import {getFieldError} from "../utils";
import {TextInput} from "react-native-paper";

type DropdownItem = { label: string, value: any };

type Props = {
  variant?: 'input' | 'button', formik: FormikProps<any>, items: DropdownItem[], field: string, label?: string,
  mb?: number
};

const Dropdown = ({variant = 'input', formik, items, field, label, mb}: Props) => {
  const [showDropDown, setShowDropDown] = useState(false);

  const selectedItem = useMemo(() => {
    return items.find(item => item.value === formik.values[field]);
  }, [items, formik.values, field]);

  const openDropdown = () => setShowDropDown(true);
  const closeDropdown = () => setShowDropDown(false);

  const handlePress = (val: any) => () => {
    closeDropdown();
    formik.setFieldValue(field, val);
  };

  return (
    <>
      {variant === 'button' ? (
        <Btn onPress={openDropdown} flex={1} row alignItems="center">
          <P fontFamily="DavisSans-Regular" ta="right" lh={55} mr={8} flex={1} tt="capitalize">
            {selectedItem?.label || 'N/A'}
          </P>
          <FontAwesome name={`chevron-${showDropDown ? 'up' : 'down'}`} size={16} color="white"/>
        </Btn>
      ) : (
        <Btn onPress={openDropdown}>
          <TextInput
            label={label} onBlur={formik.handleBlur(field)} style={{marginBottom: mb}} value={selectedItem?.label || ''}
            error={!!getFieldError(field, formik)} editable={false} underlineColor="transparent"
            right={
              <TextInput.Icon
                icon={() => <FontAwesome name={showDropDown ? 'chevron-up' : 'chevron-down'} size={16} color="white"/>}
                onPress={openDropdown}
              />
            }
          />
        </Btn>
      )}

      <Modal animationType="fade" transparent visible={showDropDown} statusBarTranslucent={false}
             hardwareAccelerated={false} onRequestClose={closeDropdown}>
        <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
          <ScrollView contentContainerStyle={MainStyle.flex1}>
            <Div minH="100%" alignItems="center" justifyContent="center">
              <Div bg="#131314" w={343} rounded={16} overflow="hidden">
                <Div position="relative" bg="#252526" justifyContent="center">
                  <P fontFamily="DavisSans-Medium" ta="center" lh={48}>{label || 'Select'}</P>
                  <FontAwesome5
                    name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                    onPress={closeDropdown}
                  />
                </Div>

                <Div w={200} mx="auto" roundedTop={4} overflow="hidden" my={30}>
                  {items.map(el => (
                    <AmountSelect key={String(el.value)} selected={el.value === formik.values[field]}
                                  onPress={handlePress(el.value)}>
                      {el.label}
                    </AmountSelect>
                  ))}
                </Div>
              </Div>
            </Div>
          </ScrollView>
        </View>
      </Modal>
    </>
  );
};

export default Dropdown;
